import ServicoHttpBase from '../http.axios'
import config from '@/config'
import Cookies from 'js-cookie'
import {
  CABECALHO_CONVERSA,
  CAMINHO_DOS_LOGS_DO_FRONT,
  conversaDoAssistenteAtual,
  criarLog
} from '@/typescript/modulos/governanca/AssistentePontotel/servicos/logDoAssistente'

const logHttp = criarLog('http')
const INICIO = Symbol('inicioDaRequisicaoDoAssistente')

/** Rota do Assistente que vira log (o envio do próprio log não vira). */
function rotaDoAssistente (url: string | undefined): boolean {
  return Boolean(url?.includes('/assistente/')) && !url?.endsWith(CAMINHO_DOS_LOGS_DO_FRONT)
}

export interface IStateAutenticacao {
  auth: { 
    authorization: string | null;
    accessToken: string | null;
    userPoolId: string | null;
    userPoolWebClientId: string | null;
  }
}

type ObterDadosDeAutenticacao = () => IStateAutenticacao

class HttpAgentePtt extends ServicoHttpBase {
  autenticacao: IStateAutenticacao
  protected urlBase: string = config.agentePttUrl
  protected urlFallback: string = config.agentePttUrl

  constructor(obterDadosDeAutenticacao: ObterDadosDeAutenticacao) {
    super(config.agentePttUrl)
    this.autenticacao = obterDadosDeAutenticacao()
  }

  protected adicionarInterceptadorDeRequisicao(): void {
    this.clienteHttp.interceptors.request.use((config) => {
      if (!config.url?.endsWith('oauth2/token')) {
        if (this.autenticacao.auth.authorization) {
          config.headers.set('Authorization', this.autenticacao.auth.authorization)
        } else {
          config.headers.set('Authorization', Cookies.get('Authorization'))
        }

        if (this.autenticacao.auth.accessToken || Cookies.get('accessToken')) {
          config.headers.set('X-PontoTel-Authorization', this.autenticacao.auth.accessToken || Cookies.get('accessToken'))
          config.headers.set('X-PontoTel-UP', this.autenticacao.auth.userPoolId || Cookies.get('userPoolId'))
          config.headers.set('X-PontoTel-DI', this.autenticacao.auth.userPoolWebClientId || Cookies.get('userPoolWebClientId'))
        }
      }

      const idiomaI18n = localStorage.getItem('idioma')
      if (idiomaI18n) {
        config.headers.set('Accept-Language', idiomaI18n)
      }

      // O id da conversa do Assistente acompanha toda chamada dele: é o que
      // junta agente, MCP e condominio no mesmo log.
      const conversa = conversaDoAssistenteAtual()
      if (conversa && config.url?.includes('/assistente/')) {
        config.headers.set(CABECALHO_CONVERSA, conversa)
      }
      if (rotaDoAssistente(config.url)) {
        (config as unknown as Record<symbol, number>)[INICIO] = performance.now()
        logHttp.debug(`→ ${config.method?.toUpperCase()} ${config.url}`, {
          params: config.params,
          corpo: config.data
        })
      }
      return config
    }, (error) => {
      return Promise.reject(error)
    })
  }

  protected adicionarInterceptadorDeResposta(): void {
    const duracao = (config: unknown) => {
      const inicio = (config as Record<symbol, number> | undefined)?.[INICIO]
      return inicio === undefined ? '' : ` em ${Math.round(performance.now() - inicio)}ms`
    }
    this.clienteHttp.interceptors.response.use((response) => {
      if (rotaDoAssistente(response.config?.url)) {
        logHttp.debug(
          `← ${response.status} ${response.config.method?.toUpperCase()} ${response.config.url}${duracao(response.config)}`,
          response.data
        )
      }
      return response
    }, (error) => {
      if (rotaDoAssistente(error?.config?.url)) {
        logHttp.error(
          `✖ ${error?.response?.status ?? 'sem resposta'} ${error.config.method?.toUpperCase()} ${error.config.url}${duracao(error.config)}`,
          error
        )
      }
      return Promise.reject(error)
    })
  }

  public obterUrlBase(): string {
    return this.urlBase
  }

  public obterUrlFallback(): string {
    return this.urlFallback
  }
}

export default HttpAgentePtt